exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.top-nav{display:flex;align-items:center;background:#fff;height:80px}ul.top-nav li{margin-bottom:0}ul.top-nav .top-nav-link{margin-right:32px;position:relative;display:block;color:#222;height:100%;white-space:nowrap;font-weight:500;line-height:80px}ul.top-nav .top-nav-link.hidden{display:none}ul.top-nav .top-nav-link.active{color:var(--secondary);position:relative}ul.top-nav .top-nav-link.active:after{content:\"\";position:absolute;height:3px;bottom:-1px;right:0;left:0;background:var(--secondary);z-index:100}", ""]);

// exports
